import Script from 'next/script';
import { useRouter } from 'next/router';

import { useFeature } from '@hooks/use-feature';
import { useCallback, useEffect } from 'react';
import { navigation } from '@constants/navigation';
import { useDeferredCallback } from '@hooks/use-deferred-callback';

const HIDDEN_ROUTES = [navigation.MENU, navigation.MENU_CATEGORIES];

const Zendesk = () => {
  const router = useRouter();
  const [send, activate] = useDeferredCallback((...args) => window?.zE?.(...args));

  const { url, showOnAllPages } = useFeature('zendesk-chat') || {};
  const enabled = !!url;
  // default to true
  const alwaysVisible = showOnAllPages !== false;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const visible = alwaysVisible || !HIDDEN_ROUTES.includes(router.route);

    const action = visible ? 'show' : 'hide';

    send('messenger', action);
  }, [enabled, send, router.route, alwaysVisible]);

  const handleOnLoad = useCallback(() => {
    activate();
  }, [activate]);

  if (!enabled) {
    return null;
  }

  return <Script id="ze-snippet" src={url} onLoad={handleOnLoad} />;
};

export { Zendesk };
